import { styled, css } from "../../../../../../../styles";

export const ContentContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-evenly",
  alignItems: "flex-start",

  height: "150px",
});

export const ButtonContainer = styled("div", {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "12px",

  padding: "32px 0 0 0",
});

export const CancelButton = styled("button", {
  height: "$13",
  padding: "0 $13",
  marginLeft: "5px",

  borderRadius: "20px",
  border: "2px solid $white",

  backgroundColor: "$white",

  gap: "$4",

  display: "flex",
  alignItems: "center",

  color: "$black",
  fontWeight: 600,
  lineHeight: "22px",
  fontSize: "$text-lg",
  fontFamily: "$openSans",

  cursor: "pointer",

  "&:focus": {
    outline: "none",
    border: "2px solid var(--colors-button-focus-border)",
  },

  "&:hover": {
    color:
      "var(--colors-measurement-modal-baseline-confirm-modal-cancel-button-hover)",
  },

  "@sm": {
    width: "80px",
    height: "26px",
    fontSize: "12px",
    marginLeft: "40px",
    paddingLeft: "19px",
  },

  variants: {
    isModal: {
      true: {
        padding: "0 $10",
      },
    },
  },
});

// CSS

export const confirmModalCss = css({
  fontFamily: "$openSans !important",
  animationDuration: "0s !important",

  ".ant-modal-content": {
    animation: "none !important",
    animationDuration: "0s !important",
    opacity: "1 !important",
    padding: "$12 $14 !important",
  },

  ".ant-modal-title": {
    fontSize: "$text-xl",
    color: "$black",
    fontWeight: "500",
    marginLeft: "5px",
  },

  ".ant-modal-footer": {
    display: "flex",
    gap: "12px",
  },
});
